import { render, staticRenderFns } from "./ReviewsSettings.vue?vue&type=template&id=4c73366b&scoped=true"
import script from "./ReviewsSettings.vue?vue&type=script&lang=js"
export * from "./ReviewsSettings.vue?vue&type=script&lang=js"
import style0 from "./ReviewsSettings.vue?vue&type=style&index=0&id=4c73366b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73366b",
  null
  
)

export default component.exports